import { TypedResponseError } from './classes.typedresponseerror.js';
import * as plugins from './plugins.js';

export class TypedTools {
  /** Trusted cancellation for this exact handler invocation. */
  public readonly abortSignal: AbortSignal;

  /**
   * Local data passed from the transport layer.
   * This can contain connection-specific context like the WebSocket peer.
   */
  public localData: Record<string, any> = {};

  constructor(abortSignalArg?: AbortSignal) {
    this.abortSignal = abortSignalArg ?? new AbortController().signal;
  }

  public async passGuards<T = any>(guardsArg: plugins.smartguard.Guard<T>[], dataArg: T) {
    const guardSet = new plugins.smartguard.GuardSet<T>(guardsArg);
    const guardResult = await guardSet.allGuardsPass(dataArg);
    if (!guardResult) {
      const failedHint = await guardSet.getFailedHint(dataArg);
      throw new TypedResponseError(`guard failed: ${failedHint}`, { failedHint });
    }
  }
}
